import React, { useState, useContext, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Paper,
  Checkbox,
  CircularProgress,
  Stack,
} from "@mui/material";


import Grid from "@mui/material/Grid2";
import { Download as DownloadIcon } from "@mui/icons-material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TablePagination from "@mui/material/TablePagination";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useNavigate } from "react-router-dom";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import * as XLSX from "xlsx";

import GeneralContext from "../GeneralContext/GeneralContext";
import InputFilter from "../GeneralComponents/InputFilter";
import PageBody from "../GeneralComponents/PageBody";
import PageButtonSimple from "../GeneralComponents/PageButtonSimple";
import PageButtonWhite from "../GeneralComponents/PageButtonWhite";
import PageButtonBlack from "../GeneralComponents/PageButtonBlack";
import PageBgBlock from "../GeneralComponents/PageBgBlock";
import ListEmpty from "../GeneralComponents/ListEmpty";
import axios from "../../api/axios";
import InputChipSelect from "../GeneralComponents/InputChipSelect";

import {ROL_ADMIN, ROL_ADMIN_SUBTEL, ROL_VAL_SUBTEL, ROL_MINEDUC_ADMIN} from "../../Constants/Constants";


const allColumns = [
  { id: "checkbox", label: "", minWidth: 20, align: "left" },
  { id: "rbd", label: "RBD", minWidth: 70, align: "center" },
  { id: "Zona", label: "Zona", minWidth: 100 },
  { id: "Nombre", label: "Nombre", minWidth: 100 },
  { id: "operador", label: "Operador", minWidth: 100 },
  { id: "Fecha_de_Alta", label: "Fecha de Alta", minWidth: 80 },
  { id: "Fecha_Baja", label: "Fecha de Baja", minWidth: 90 },
  { id: "Fecha_recepcion", label: "Recepción de obras", minWidth: 90 },
  { id: "Fecha_servicio", label: "Inicio de servicio", minWidth: 90 },
  { id: "estado", label: "Estado", minWidth: 70 },
  { id: "estado_pago", label: "Estado Pago", minWidth: 80 },
  { id: "concurso", label: "Convocatoria", minWidth: 70 },
  { id: "detalle", label: "Ficha RBD", minWidth: 80 },
];

const arrayFields = ["rbd"];

export default function RbdGenericList({
  columnOrder = [],
  filtersConfig = [],
  pageTitleOverride = "Listado estado de parque",
}) {


  const [rows, setRows] = useState([]);
  const [filters, setFilters] = useState({});
  const [tableData, setTableData] = useState([]);
  const [filteredColumns, setFilteredColumns] = useState([]);
  const [loadingTable, setLoadingTable] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selected, setSelected] = useState([]);
  const { setPageTitle, includeRol, userSesion } = useContext(GeneralContext);
  const [loadingPDF, setLoadingPDF] = useState(false);

    const mapParque = (data: any[]) =>
    data.map((row, index) => ({
      ...row,
      estado_pago: row["estado_pago"] === "Facturar"  ? "Factura"
          : row["estado_pago"] === "Devengar"
          ? "Devengo"
          : "No facturando",
      estado:
        row["Estado"] === "Activo" || row["Estado"] === "Facturar"
          ? "Conectado"
          : row["Estado"] === "NYA"
          ? "En proceso"
          : "Baja",
      operador: row["Operador"] || "Desconocido",
      Fecha_de_Alta: row["Fecha_de_Alta"]?.split("T")[0] || "",
      Fecha_Baja: row["Fecha_de_Baja"]?.split("T")[0] || null,
      Fecha_servicio: row["Fecha_de_Alta"]?.split("T")[0] || null,
      Fecha_recepcion: row["fecha_alta_devengo"]?.split("T")[0] || null,
      Fecha_Baja_link: row["oficio_baja_url"] || "",
      Fecha_servicio_link: row["oficio_inicio_servicio_url"] || "",
      Fecha_recepcion_link: row["oficio_recepcion_de_obra_url"] || "",

      Fecha_Baja_periodo: row["Fecha_de_Baja"]?.slice(0, 7) || null,
      Fecha_servicio_periodo: row["Fecha_de_Alta"]?.slice(0, 7) || null,
      Fecha_recepcion_periodo: row["fecha_alta_devengo"]?.slice(0, 7) || null,
      index,
      id: index,
    }));


const fetchData = async () => {
    setLoadingTable(true);
    try {
      let parqueResp;

      if (includeRol([ROL_ADMIN, ROL_ADMIN_SUBTEL, ROL_VAL_SUBTEL, ROL_MINEDUC_ADMIN])) {

        parqueResp = await axios.getParque();
      } else {

        const opResp = await axios.getOperator(userSesion.id);
        const id_operador = opResp?.data?.id_operador;

        if (id_operador  != null){
            parqueResp = await axios.getParque(id_operador);
        }else{
          parqueResp = [];
        }

        
      }

      const modified = mapParque(parqueResp.data || []);
      setRows(modified);
      setTableData(modified);
    } catch (e) {
      console.error("Error cargando parque:", e);
      setRows([]);
      setTableData([]);
    } finally {
      setLoadingTable(false);
    }

    setFilteredColumns(
      columnOrder.length > 0
        ? columnOrder.map((id) => allColumns.find((c) => c.id === id)).filter(Boolean)
        : allColumns
    );
  };

  const downloadPDF = (url, rbd) => {
    setLoadingPDF(true);
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/pdf",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.blob();
      })
      .then((blob) => {
        const blobUrl = window.URL.createObjectURL(blob);
        const a = document.createElement("a");

        a.href = blobUrl;
        a.download = rbd + ".pdf";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(blobUrl);
        setLoadingPDF(false);
      })
      .catch((error) => {
        setLoadingPDF(false);
        console.error("Error al descargar el archivo:", error);
        window.open(url, "_blank");
      });
  };

  const filterRecords = (name, value) => {
    const filterObj = { ...filters, [name]: value };

    const isEmpty =
      value === null || (Array.isArray(value) && value.length === 0);

    if (isEmpty) {
      delete filterObj[name];
    }

    const newTableData =
      Object.keys(filterObj).length !== 0
        ? rows.filter((item) =>
            Object.entries(filterObj).every(([key, val]) => {
              const itemValue = item[key];

              if (arrayFields.includes(key) && Array.isArray(val)) {
                return val.includes(itemValue);
              }

              return itemValue === val;
            })
          )
        : rows;

    if (JSON.stringify(newTableData) !== JSON.stringify(tableData)) {
      setSelected([]);
    }

    const maxPage = Math.floor((newTableData.length - 1) / rowsPerPage);
    if (page > maxPage) {
      setPage(0);
    }

    setFilters(filterObj);
    setTableData(newTableData);
  };

  const downloadXLS = () => {
    const selectedRows = tableData.filter((row) =>
      selected.includes(row.index)
    );
    const filteredData = selectedRows.map((row) => ({
      rbd: row.rbd,
      Zona: row.Zona,
      operador: row.operador,
      Nombre: row.Nombre,
      Convocatoria: row.concurso,
      Fecha_de_Baja: row.Fecha_Baja,
      Fecha_de_Alta: row.Fecha_de_Alta,
      estado: row.estado,
    }));
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(filteredData);
    XLSX.utils.book_append_sheet(wb, ws, "Tabla");
    XLSX.writeFile(wb, "tabla.xlsx");
  };

  const handleSelectAll = (event) => {
    setSelected(event.target.checked ? tableData.map((row) => row.index) : []);
  };

  const handleCheckboxClick = (index) => {
    setSelected((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const isSelected = (index) => selected.includes(index);

  useEffect(() => {
    setPageTitle(pageTitleOverride);
    fetchData();
  }, []);

  return (
    <>
      <Grid
        container
        spacing={1}
        sx={{ mb: 0, marginTop: "-2rem" }}
        alignItems="flex-start" // <- evita que los elementos se estiren en vertical
      >
        {/* Filtros agrupados */}
        <Grid size={6}>
          <Grid container spacing={1} sx={{ mb: 3 }}>
            {filtersConfig.map(({ item, name, size = 6 }) => (
              <Grid key={item} size={size}>
                <InputFilter
                  data={rows}
                  item={item}
                  name={name}
                  callback={filterRecords}
                />
              </Grid>
            ))}
          </Grid>
        </Grid>

        <Grid container size={6} spacing={0}>
          <Grid size={12}>
            <InputChipSelect
              data={rows}
              item={"rbd"}
              name={"RBD"}
              callback={filterRecords}
            />
          </Grid>
        </Grid>
      </Grid>

      {loadingTable ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="50vh"
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          <Paper sx={{ mb: 2, p: 1, textAlign: "center" }}>
            <Typography
              variant="h1"
              color="inherit"
              noWrap
              sx={{ textAlign: "center", padding: "0.5rem" }}
            >
              {pageTitleOverride}
            </Typography>
          </Paper>

          <PageBgBlock pad="0">
            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    {filteredColumns.map((col) => (
                      <TableCell key={col.id} align={col.align || "left"}>
                        {col.id === "checkbox" ? (
                          <Checkbox
                            indeterminate={
                              selected.length > 0 &&
                              selected.length < tableData.length
                            }
                            checked={
                              tableData.length > 0 &&
                              selected.length === tableData.length
                            }
                            onChange={handleSelectAll}
                          />
                        ) : (
                          col.label
                        )}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow
                        key={row.index}
                        hover
                        selected={isSelected(row.index)}
                      >
                        {filteredColumns.map((col) => (
                          <TableCell key={col.id} align={col.align || "left"}>
                            {col.id === "checkbox" ? (
                              <Checkbox
                                checked={isSelected(row.index)}
                                onClick={() => handleCheckboxClick(row.index)}
                              />
                            ) : col.id === "detalle" ? (
                              <Button
                                onClick={(e) => {
                                  e.stopPropagation();

                                  window.open(
                                    "/establecimiento_detalle/" + row["rbd"],
                                    "_blank"
                                  );
                                }}
                                key={`${col.id}.button.${index}`}
                                variant="text"
                              >
                                <Typography
                                  key={`${col.id}.typ.${index}`}
                                  sx={{
                                    color: "#111",
                                    textTransform: "capitalize",
                                    textDecoration: "underline",
                                  }}
                                >
                                  Ver
                                </Typography>
                              </Button>
                            ) : col.id.startsWith("Fecha_") && row[col.id] ? (
                              <PageButtonSimple
                                disabled={!row[col.id + "_link"]}
                                width="105px"
                                pad="0.2rem 0.5rem"
                                fs="0.6875rem"
                                startIcon={<DownloadIcon />}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  downloadPDF(
                                    row[col.id + "_link"],
                                    row[col.rbd]
                                  );
                                }}
                              >
                                <Stack>
                                  <span>{row[col.id]}</span>
                                </Stack>
                              </PageButtonSimple>
                            ) : col.id.startsWith("Fecha_") ? (
                              <Stack>
                                <span>
                                  <b>{"-"}</b>
                                </span>
                              </Stack>
                            ) : col.id === "estado" ? (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  flexWrap: "no-wrap",
                                }}
                              >
                                <FiberManualRecordIcon
                                  sx={{
                                    fontSize: "0.75rem",
                                    color:
                                      row[col.id] === "Conectado"
                                        ? "#41AE43"
                                        : row[col.id] === "En proceso"
                                        ? "#ABABB5"
                                        : "#FB3B3B",
                                    marginRight: "0.5rem",
                                  }}
                                />

                                {row[col.id]}
                              </div>
                            ) : (
                              row[col.id]
                            )}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
              {tableData.length === 0 && <ListEmpty />}
              <TablePagination
                component="div"
                rowsPerPageOptions={[10, 25, 100]}
                count={tableData.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={(e, p) => setPage(p)}
                onRowsPerPageChange={(e) => {
                  setRowsPerPage(parseInt(e.target.value, 10));
                  setPage(0);
                }}
              />
            </TableContainer>
          </PageBgBlock>

          <Grid container spacing={2} justifyContent="flex-end" sx={{ pt: 2 }}>
            <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
              <PageButtonWhite onClick={downloadXLS} width="100%" disabled={selected.length === 0}>
                Descargar selección (.xls)
              </PageButtonWhite>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
}
